import { Box, Divider, Grid } from "@mui/material"
import dayjs from "dayjs"
import React from "react"
import { NA } from "src/constants/common"
import { theme } from "src/providers/ThemeProvider"
import { Button, GreenChecked, Text } from "src/shared"
import { GiftExchangeHistoryModel } from "src/types"

interface IItemContentProps {
  onOpenGiftRecieve: () => void
  onOpenGiftChange: () => void
  data?: GiftExchangeHistoryModel
  isLastItem: boolean
}

const ItemContent = ({
  onOpenGiftRecieve,
  onOpenGiftChange,
  isLastItem = false,
  data,
}: IItemContentProps) => {
  return (
    <React.Fragment key={`${data?.ProductName}`}>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        flexWrap="nowrap"
        spacing={1}
        gap={2}
        sx={{
          padding: theme.spacing(0, 3),
          [theme.breakpoints.down(500)]: {
            padding: theme.spacing(0, 1.5),
          },
        }}
      >
        <Grid xs={9} item>
          <Grid container columnGap={1} flexWrap="nowrap">
            <Grid
              item
              sx={{
                width: 80,
                height: 80,
                "& > img": {
                  display: "block",
                  [theme.breakpoints.down(480)]: {
                    width: 40,
                    height: 40,
                  },
                },
              }}
            >
              <img
                width="100%"
                height="100%"
                src={`${process.env.REACT_APP_IMAGE_URL}/${data?.ProductDefaultImage}`}
                alt={"Gift_image"}
              />
            </Grid>
            <Grid item>
              <Grid container flexDirection="column">
                <Text
                  sx={{
                    wordBreak: "break-all",
                    whiteSpace: "initial",
                    [theme.breakpoints.down(460)]: {
                      fontSize: 13,
                      lineHeight: "18px",
                    },
                  }}
                  maxWidth="95%"
                  lineHeight="21.1px"
                  fontSize={16}
                  fontWeight={500}
                >
                  {data?.ProductName || NA}
                </Text>
                <Text
                  lineHeight="16px"
                  fontSize={12}
                  color={theme.palette.grey[600]}
                  sx={{
                    [theme.breakpoints.down(460)]: {
                      fontSize: 11,
                      lineHeight: "16px",
                    },
                  }}
                >
                  Số lượng: 1
                </Text>
                <Box
                  mt={1.5}
                  sx={{
                    [theme.breakpoints.down(460)]: {
                      "& img": {
                        width: 15,
                        height: 20,
                      },
                    },
                  }}
                  columnGap={1}
                  display="flex"
                  alignItems="center"
                >
                  <img
                    src="/assets/images/location_image.png"
                    alt="location_image"
                    width={20}
                    height={30}
                  />
                  <Box
                    sx={{
                      " & p": {
                        lineHeight: "17.15px",
                        color: theme.palette.grey[600],
                        fontSize: 13,
                        whiteSpace: "initial",
                        wordBreak: "break-all",
                        [theme.breakpoints.down(460)]: {
                          fontSize: 11,
                          lineHeight: "16px",
                        },
                      },
                    }}
                  >
                    <Text>{data?.Address || NA}</Text>
                    <Text>{dayjs(data?.CreatedDate).format("DD/MM/YYYY")}</Text>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid xs={3} item flexGrow={1}>
          <Box
            sx={{
              float: "right",
            }}
            alignItems="center"
            display="flex"
            flexDirection="column"
            justifyContent="end"
            textAlign="center"
            width="100%"
            rowGap={1}
          >
            {data?.IsOrder ? (
              <>
                <Button
                  sx={{
                    [theme.breakpoints.down(500)]: {
                      height: 36,
                      width: 90,
                      "& > p": {
                        fontSize: 14,
                        lineHeight: "18px",
                      },
                    },
                    [theme.breakpoints.down(400)]: {
                      height: 30,
                      width: 70,
                      "& > p": {
                        fontSize: 12,
                        lineHeight: "14px",
                      },
                    },
                  }}
                  onClick={onOpenGiftRecieve}
                >
                  Nhận quà
                </Button>
                <Button
                  variant="text"
                  onClick={onOpenGiftChange}
                  sx={{
                    "&:hover": {
                      "& > p": {
                        fontWeight: "bold",
                      },
                      backgroundColor: "inherit",
                    },
                    "& > p": {
                      color: "#E75F2B",
                      fontSize: 13,
                      lineHeight: "17.15px",
                      fontWeight: 400,
                      textTransform: "none",
                    },
                    [theme.breakpoints.down(500)]: {
                      width: "auto",
                    },
                  }}
                >
                  Thay đổi quà khác
                </Button>
              </>
            ) : (
              <>
                <GreenChecked />
                <Text
                  maxWidth={96}
                  fontSize={15}
                  lineHeight={"21px"}
                  color={theme.palette.info.main}
                >
                  Đã nhận quà tại cửa hàng
                </Text>
              </>
            )}
          </Box>
        </Grid>
      </Grid>
      {!isLastItem && (
        <Box
          width="100%"
          p={3}
          sx={{
            [theme.breakpoints.down(500)]: {
              p: 1.5,
            },
          }}
        >
          <Divider
            sx={{
              borderColor: "#EDEDED",
            }}
          />
        </Box>
      )}
    </React.Fragment>
  )
}

export default ItemContent
